import Form from '@/ui/Form'
import Title from '@/ui/Title';
import { useRouter } from 'next/router';
import React from 'react';
import classes from "./styles.module.scss";

const FormSection = ({title, formId, jobId, redirect_url}) => {
  const router = useRouter()

  function onSubmitDone() {
    router.push(redirect_url);
  }

  return (
    <div className={classes.form}>
      <Title title={title} tag="h4" className={classes.title} />
      <Form formId={formId} jobId={jobId} onSubmitDone={onSubmitDone} />
    </div>
  )
}

export default FormSection